export default __webpack_public_path__ + "static/media/ASTInfo.1ef6f6ab.md";